import { useSelector } from 'react-redux';

function usePayment() {
  const payment = useSelector((state) => state.payment.toJS());
  return payment;
}

export default usePayment;
